import { render } from "./FeedbackSection.vue?vue&type=template&id=7a8b05c4"
const script = {}

import "./FeedbackSection.vue?vue&type=style&index=0&id=7a8b05c4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__